import { type Episode } from '../playalong/types'

const YOUTUBE_HTTP_API_KEY = 'AIzaSyDDbLXtnfkSRWIs08eEJ6zAsPCg7lGd1-w'

const TWITCH_HTTP_API_KEY = 'gkw47mck22xxf0elsnju7vz3w61bta'
const TWITCH_CLIENT_ID = 'gp762nuuoqcoxypju8c569th9wz7q5'

function getYouTubeVideoId(url: string): string | null {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    const match = url.match(regex)
    return (match != null) ? match[1] : null
}

const getYoutubeChannelDetailsAPIUrl = (channelId: string): string => {
    return `https://youtube.googleapis.com/youtube/v3/channels?part=snippet&forHandle=${channelId}&key=${YOUTUBE_HTTP_API_KEY}`
}

const getYoutubeOEmbedAPIUrl = (youtubeUrl: string): string | null => {
    const youtubeID = getYouTubeVideoId(youtubeUrl)
    if (youtubeID === null) {
        return null
    }
    return `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${youtubeID}&format=json`
}

const getTwitchVideoDetailsAPIUrl = (twitchUrl: string): string | null => {
    const twitchID = twitchUrl.split('/videos/')[1]
    if (twitchID === null) {
        return null
    }
    return `https://api.twitch.tv/helix/videos?id=${twitchID}`
}

const getTwitchOUserDetailsAPIUrl = (twitchUserId: string): string => {
    return `https://api.twitch.tv/helix/users?login=${twitchUserId}`
}

const blankEpisode: Episode = {
    title: '',
    episode: '',
    premiereDate: '',
    releaseDate: '',
    videoUrl: '',
    videoPreview: '',
    startTime: 0,
    endTime: 0,
    totalPrompts: 0,
    events: [],
    introMusic: {
        source: 'none',
        url: '',
        startTime: 0,
        endTime: 1

    },
    promptMusic: {
        source: 'none',
        url: '',
        startTime: 0,
        endTime: 1
    },
    series: {
        name: '',
        description: '',
        thumbnail: '',
        creator: {
            name: '',
            description: '',
            channelIcon: '',
            qrCode: '',
            platforms: {
                content: {
                    youtube: ''
                }
            }
        },
        episodes: []
    }
}

const slugify = (str: string): string => {
    str = str.replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
    str = str.toLowerCase() // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-') // remove consecutive hyphens
    return str
}

export { getYouTubeVideoId, getYoutubeOEmbedAPIUrl, getYoutubeChannelDetailsAPIUrl, getTwitchVideoDetailsAPIUrl, getTwitchOUserDetailsAPIUrl, blankEpisode, slugify, TWITCH_HTTP_API_KEY, TWITCH_CLIENT_ID }
